import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "../../../../parts/dropdown";
import SvgIcon from "../../../../parts/SvgIcon";

const TYPES = ["email", "delay", "filter"];

// The "+" after the last card, or (shown on hover) between two cards: picks the type of the step that goes there
const AddStep = ({ onAdd, onDrop, highlight, last }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key) => t(`emailAutomations.builder.add.${key}`);
  // A step is being dragged over this place
  const [over, setOver] = useState(false);
  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: a drop zone for moving a step; the "+" inside is the keyboard way to add one
    <div //NOSONAR
      role="presentation"
      className={`ab-add${highlight ? " ab-add--first" : ""}${last ? "" : " ab-add--between"}`}
      data-over={over ? "" : undefined}
      onDragOver={(event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
      }}
      onDragEnter={(event) => {
        event.preventDefault();
        setOver(true);
      }}
      onDragLeave={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) setOver(false);
      }}
      onDrop={(event) => {
        setOver(false);
        onDrop?.(event);
      }}
    >
      <Dropdown
        summaryText="+"
        options={TYPES.map((type) => ({
          text: (
            <span className={`ab-add-option ab-add-option--${type}`}>
              <span className="ab-add-option__icon">
                <SvgIcon
                  src={`/img/new-icons/step-${type}.svg`}
                  useCurrentColor
                  classNames="size-5.5 shrink-0"
                  aria-hidden="true"
                />
              </span>
              {tr(type)}
            </span>
          ),
          value: type,
        }))}
        onSelectFn={onAdd}
        overlay
      />
    </div>
  );
};

AddStep.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onDrop: PropTypes.func,
  highlight: PropTypes.bool,
  last: PropTypes.bool,
};

export default AddStep;
